import { axiosClient } from "./axiosClient";

// Zgłoszenie błędu — jak „zgłoś głosowanie": tylko zalogowani, trafia do panelu admina.
// E-mail bierze backend z konta.
export const createBugReport = (message: string, context?: string, platform: string = "web") =>
  axiosClient.post<{ id: number; status: string }>("bug_reports", { message, context, platform });

// Wnioski o dostęp do API — admin rozpatruje w panelu, zatwierdzenie ustawia api_access.
export type ApiAccessStatus = { api_access: boolean; pending: boolean };

export const getApiAccessStatus = () => axiosClient.get<ApiAccessStatus>("api_access_requests/status");

export const requestApiAccess = (justification: string) =>
  axiosClient.post<{ id: number; status: string }>("api_access_requests", { justification });
